import { MAG_DOOR_STATUS, MAG_LOCK_STATUS } from 'utils/constants'
import { useHistory, useParams } from 'react-router-dom'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { saveFirstLaunch } from './storage'
import { useEffect } from 'react'

const SplashButton = ({ mags, setMags, close }) => {

  const { number } = useParams()
  const { push } = useHistory()
  const { t } = useTranslation('splashScreen')

  const numValue = Number(number || 0)
  const lastIndex = mags.length - 1
  const isLast = lastIndex === numValue
  const lockStatus = mags[lastIndex].lock

  const updateStatus = (values) => {
    if (mags[lastIndex].door !== MAG_DOOR_STATUS.closed) return
    setMags(m => {
      const copy = [...m]
      copy[lastIndex] = {
        ...copy[lastIndex],
        ...values,
      }
      return copy
    })
  }

  useEffect(() => {
    if (isLast && lockStatus === MAG_LOCK_STATUS.unlocked) {
      let openingTimeout
      const timeout = setTimeout(() => {
        updateStatus({ door: MAG_DOOR_STATUS.opened })
        openingTimeout = setTimeout(() => {
          saveFirstLaunch()
          close()
        }, 2000)
      }, 1000)

      return () => {
        clearTimeout(timeout)
        clearTimeout(openingTimeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [close, isLast, lockStatus])

  return (
    <div className='splash__button'>
      <ArrowBtn
        enlarged
        text={t(isLast ? 'getStarted' : 'next')}
        action={() => isLast
          ? mags[lastIndex].door === MAG_DOOR_STATUS.opened
            ? saveFirstLaunch()
            : updateStatus({ lock: MAG_LOCK_STATUS.unlocked })
          : push(`/splash/${number ? numValue + 1 : '1'}`)} />
    </div>
  )
}

export default SplashButton